import ResponsiveHelper from "../utils/ResponsiveHelper";
// import "bootstrap/dist/js/bootstrap.bundle.js";
import BsAccordion from "../components/BsAccordion";

export default class Speaker {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initResponsiveHelper();
    this.initBsAccordion();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initBsAccordion() {
    const spkAccordion = document.querySelector("#accordion-spk");
    if (spkAccordion) {
      this.accd = new BsAccordion(spkAccordion);
    }
  }

  resize() {
    // console.log("resize from Homepage.js");
  }
}
